module.exports = __webpack_public_path__ + "img/multitank_box.68df70fd.jpg";